import React, { useEffect, useState } from "react";
import axios from "axios";
import "./MorningThought.css";
import { useSelector } from "react-redux";

export default function MorningThought() {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const wantedCodes = ["1067", "1064", "1062", "1055", "1063"].slice(0, 5);

  useEffect(() => {
    const fetchEmployees = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        setError("No authentication token found");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/?name=&department=&status=true&employee_type=`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );

        const found = wantedCodes
          .map((code) =>
            response.data.find((emp) => emp.employee_code === code),
          )
          .filter(Boolean);

        const employeesWithSelection = found.map((emp) => ({
          ...emp,
          isSelected: false,
        }));

        setEmployees(employeesWithSelection);
      } catch (err) {
        console.error("Failed to load employees:", err);
        setError("Could not load team members");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployees();
  }, []);

  const toggleSelection = (employeeCode) => {
    setEmployees((prev) =>
      prev.map((emp) =>
        emp.employee_code === employeeCode
          ? { ...emp, isSelected: !emp.isSelected }
          : emp,
      ),
    );
  };

  const handleSave = () => {
    const selected = employees.filter((emp) => emp.isSelected);
    if (selected.length === 0) {
      alert("No employees selected.");
      return;
    }
    console.log(
      "Saving:",
      selected.map((e) => e.employee_code),
    );
    alert(`Saved ${selected.length} employee(s)`);
    // → replace with real API call later
  };

  const staticDate = "04/03/2026";

  const permissions = useSelector((state) => state.emp.permissions);

  return (
    <div className="morning-thought-card">
      <div className="card-header">{staticDate} Morning Thought</div>

      {loading ? (
        <div className="loading">Loading team members...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : employees.length === 0 ? (
        <div className="no-data">No selected employees found</div>
      ) : (
        <>
          <ul className="names-list">
            {employees.map((emp) => {
              const checkboxId = `chk-${emp.employee_code}`;

              return (
                <li key={emp.employee_code} className="employee-row">
                  {permissions.includes("adminmanagementID") ? (
                    <input
                      type="checkbox"
                      id={checkboxId}
                      checked={emp.isSelected}
                      onChange={() => toggleSelection(emp.employee_code)}
                      className="morning-checkbox"
                    />
                  ) : null}

                  <label htmlFor={checkboxId} className="row-label">
                    <div
                      className="imgbg"
                      style={{
                        backgroundImage: `url(${emp.profile_photo || "/assets/user.png"})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                    <p className="name">{emp.name || "—"}</p>
                  </label>
                </li>
              );
            })}

            {/* Empty placeholder slots */}
            {Array.from({ length: 5 - employees.length }).map((_, i) => (
              <li key={`empty-${i}`} className="employee-row placeholder">
                <div className="imgbg empty" />
                <p className="name">—</p>
              </li>
            ))}
          </ul>
          {permissions.includes("adminmanagementID") ? (
            <div className="card-footer">
              <button className="save-button" onClick={handleSave}>
                Save
              </button>
            </div>
          ) : null}
        </>
      )}
    </div>
  );
}
